import script from "./AdminToastStack.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminToastStack.vue?vue&type=script&setup=true&lang=js"

import "./AdminToastStack.vue?vue&type=style&index=0&id=5f433a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f433a04"]])

export default __exports__